module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_8023.2ffea504.png";